import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import './MobileLogin.css';
import api from '../../../hooks/api';

// تبدیل اعداد فارسی و عربی به انگلیسی
const toEnglishDigits = (str) => {
    if (!str) return '';
    return str
        .toString()
        .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
        .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
};

const MobileLogin = () => {
    const [step, setStep] = useState(1);
    const [mobile, setMobile] = useState('');
    const [otp, setOtp] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    // کنترل ورودی موبایل (حداکثر ۱۱ رقم)
    const handleMobileChange = (e) => {
        const rawValue = toEnglishDigits(e.target.value);
        const numericOnly = rawValue.replace(/\D/g, '');
        if (numericOnly.length <= 11) {
            setMobile(numericOnly);
        }
    };

    // کنترل ورودی کد تایید (حداکثر ۶ رقم)
    const handleOtpChange = (e) => {
        const rawValue = toEnglishDigits(e.target.value);
        const numericOnly = rawValue.replace(/\D/g, '');
        if (numericOnly.length <= 6) {
            setOtp(numericOnly);
        }
    };

    // مرحله ۱: ارسال شماره موبایل و درخواست کد
    const handleRequestOtp = async (e) => {
        e.preventDefault();
        if (mobile.length < 10) {
            toast.error("شماره موبایل نامعتبر است");
            return;
        }

        setIsLoading(true);
        try {
            const res = await api.post('mobile/otp/login', { mobile });
            const resData = res.data;

            if (resData && resData.success === false) {
                toast.error(resData.message || "خطا در ارسال کد");
            } else {
                toast.success(resData?.message || "کد تایید پیامک شد");
                setStep(2);
            }
        } catch (err) {
            const errMsg = err.response?.data?.message || "خطا در برقراری ارتباط با سرور";
            toast.error(errMsg);
        } finally {
            setIsLoading(false);
        }
    };

    // مرحله ۲: بررسی کد تایید و ورود نهایی
    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        if (otp.length < 4) {
            toast.error("کد تایید باید حداقل ۴ رقم باشد");
            return;
        }

        setIsLoading(true);
        try {
            const res = await api.post('mobile/otp/verify', { mobile, otp });
            const resData = res.data;

            if (resData && resData.success === false) {
                toast.error(resData.message || "کد تایید نادرست است");
                setIsLoading(false);
                return;
            }

            // استخراج توکن و اطلاعات کاربر
            const token = 
                resData?.data?.token || 
                resData?.token || 
                resData?.access_token ||
                resData?.data?.access_token;

            const user = resData?.data?.user || resData?.user;

            if (token) {
                localStorage.setItem("ACCESS_TOKEN", token);
            }

            if (user?.id) {
                localStorage.setItem("USER_ID", user.id);
            }

            // بررسی وضعیت تکمیل پروفایل
            const isComplete = Boolean(
                resData?.data?.isProfileComplete ??
                resData?.data?.is_profile_complete ??
                resData?.isProfileComplete ??
                resData?.is_profile_complete ??
                user?.isProfileComplete ??
                user?.is_profile_complete
            );

            if (isComplete) {
                localStorage.setItem("isProfileComplete", "true");
            } else {
                localStorage.removeItem("isProfileComplete");
            }

            // اطلاع‌رسانی به کل برنامه جهت به‌روزرسانی استیت لاگین
            window.dispatchEvent(new Event('profileUpdated'));
            
            toast.success("ورود با موفقیت انجام شد");

            // هدایت به مسیر مناسب
            if (!isComplete) {
                navigate('/Register');
            } else {
                navigate('/');
            }
        } catch (err) {
            const errMsg = err.response?.data?.message || "کد وارد شده صحیح نمی‌باشد";
            toast.error(errMsg);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="mobile-login-container">
            <div className="login-box">
                <h2>ورود به فروشگاه</h2>
                {step === 1 ? (
                    <form onSubmit={handleRequestOtp}>
                        <p>شماره موبایل خود را وارد کنید</p>
                        <input
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            className="login-input"
                            placeholder="09123456789"
                            value={mobile}
                            onChange={handleMobileChange}
                            dir="ltr"
                            autoFocus
                        />
                        <button type="submit" className="login-btn" disabled={isLoading}>
                            {isLoading ? 'در حال ارسال...' : 'دریافت کد تایید'}
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleVerifyOtp}>
                        <p>کد پیامک شده به {mobile} را وارد کنید</p>
                        <input
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            className="login-input"
                            placeholder="کد تایید"
                            value={otp}
                            onChange={handleOtpChange}
                            dir="ltr"
                            autoFocus
                        />
                        <button type="submit" className="login-btn" disabled={isLoading}>
                            {isLoading ? 'در حال بررسی...' : 'تایید و ورود'}
                        </button>
                        <button
                            type="button"
                            className="login-back-btn"
                            onClick={() => {
                                setStep(1);
                                setOtp('');
                            }}
                            disabled={isLoading}
                        >
                            تغییر شماره موبایل
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default MobileLogin;
